export const ADD_CHIT_STARTED = 'ADD_CHIT_STARTED';
export const ADD_CHIT_COMPLETED = 'ADD_CHIT_COMPLETED';
export const ADD_CHIT_ERROR = 'ADD_CHIT_ERROR';

export const FETCH_CHITS_STARTED = 'FETCH_CHITS_STARTED';
export const FETCH_CHITS_COMPLETED = 'FETCH_CHITS_COMPLETED';
export const FETCH_CHITS_ERROR = 'FETCH_CHITS_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/chitActionTypes.js